import contract from 'truffle-contract';
import { REWARDS_ADDRESS, ADDRESS_MVU_TOKEN, ADDRESS_MEVU } from '../config';
const artifact_mevu = require('./Mevu.json'),
    artifact_rewards = require('./Rewards.json'),
    artifact_safe_mevu = require('./SafeMevu.json'),
    contractMevu = contract(artifact_mevu),
    contractRewards = contract(artifact_rewards),
    contractSafeMevu = contract(artifact_safe_mevu);


const _web3 = new Web3();
_web3.setProvider(new _web3.providers.HttpProvider());
contractMevu.setProvider(_web3.currentProvider);
contractRewards.setProvider(_web3.currentProvider);
contractSafeMevu.setProvider(_web3.currentProvider);

export const web3 = _web3
export const mevuContractInstance = contractMevu.at(ADDRESS_MEVU);
export const rewardsContractInstance = contractRewards.at(REWARDS_ADDRESS);
export const safeMevuContractInstance = contractSafeMevu.at(ADDRESS_MVU_TOKEN);


// WEBPACK FOOTER //
// ./src/contracts/index.js